export default (token) => {
    const planPrefix = 'store_insight_contract_workflow_for_edit_plans_obj_attributes_'
    const optionPrefix = 'store_insight_contract_workflow_for_edit_options_obj_attributes_'
    const commissionPrefix = 'store_insight_contract_workflow_for_edit_commissions_obj_attributes_'
    const campaignPrefix = 'store_insight_contract_workflow_for_edit_campaigns_obj_attributes_'

    const xhr = new XMLHttpRequest()
    xhr.open('GET', '/api/v1/store_insight_contract_workflows/information')
    xhr.setRequestHeader( 'X-CSRF-Token', token)
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send()
    xhr.addEventListener('load', function(result) {
        if(result.currentTarget.status != 200) {
            alert(result.currentTarget.responseText)
            return
        }
        if(result.currentTarget.responseText.length == 0) {
            return
        }

        const json = JSON.parse(result.currentTarget.responseText)

        Array.from(document.getElementsByClassName("plan_row")).forEach(element => {
            setPlanInfo(element, json.plan)
        });

        Array.from(document.getElementsByClassName("option_row")).forEach(element => {
            setOptionInfo(element, json.option)
        });

        Array.from(document.getElementsByClassName("commission_row")).forEach(element => {
            setCommissionInfo(element, json.commission)
        });

        Array.from(document.getElementsByClassName("campaign_row")).forEach(element => {
            setCampaignInfo(element, json.campaign)
        });
    })

    const setPlanInfo = (el, json) => {
        let contractPlanId = null
        Array.from(el.getElementsByTagName("input")).some(inputEl => {
            if(!inputEl.id.match(new RegExp(`^${planPrefix}[0-9]+_id`), "")) {
                return false
            }
            if(inputEl.value.length === 0) return false
            contractPlanId = inputEl.value
            return true
        })

        Array.from(el.getElementsByClassName("watch_changes")).forEach(element => {
            let planId = element.value
            if(planId === '') {
                resetPlan(el)
                return
            }
            planId = planId - 0

            let jsonParams = null
            Array.from(json).some(params => {
                if(params.id !== planId) {
                    return false
                }
                jsonParams = params
                return true
            })
            if(jsonParams === null) return  // マスタにない

            Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
                let name = inputEl.id
                const column = name.replace(new RegExp(`^${planPrefix}[0-9]+_`), "")
                switch(column) {
                    case 'custom_basic_price':
                        if(contractPlanId !== null) {
                            // 既に登録済みなので編集不可
                            inputEl.readOnly = true
                            inputEl.disabled = true
                            if(jsonParams.custom_basic_price !== null) {
                                inputEl.value = jsonParams.custom_basic_price
                            }
                        } else {
                            // まだ本登録されていない
                            if(jsonParams.custom_basic_price === null) {
                                // プラン固定の設定がないので入力可
                                inputEl.readOnly = false
                                inputEl.disabled = false
                            } else {
                                // プラン固定の設定があるため入力不可
                                inputEl.readOnly = true
                                inputEl.disabled = true
                                inputEl.value = jsonParams.custom_basic_price
                            }
                        }
                        break
                    case 'custom_free_limit':
                        if(contractPlanId !== null) {
                            // 既に登録済みなので編集不可
                            inputEl.readOnly = true
                            inputEl.disabled = true
                            if(jsonParams.custom_free_limit !== null) {
                                inputEl.value = jsonParams.custom_free_limit
                            }
                        } else {
                            // まだ本登録されていない
                            if(jsonParams.custom_free_limit === null) {
                                // プラン固定の設定がないので入力可
                                inputEl.readOnly = false
                                inputEl.disabled = false
                            } else {
                                // プラン固定の設定があるため入力不可
                                inputEl.readOnly = true
                                inputEl.disabled = true
                                inputEl.value = jsonParams.custom_free_limit
                            }
                        }
                        break
                    case 'custom_excessive_unit_price':
                        if(contractPlanId !== null) {
                            // 既に登録済みなので編集不可
                            inputEl.readOnly = true
                            inputEl.disabled = true
                            if(jsonParams.custom_excessive_unit_price !== null) {
                                inputEl.value = jsonParams.custom_excessive_unit_price
                            }
                        } else {
                            // まだ本登録されていない
                            if(jsonParams.custom_excessive_unit_price === null) {
                                // プラン固定の設定がないので入力可
                                inputEl.readOnly = false
                                inputEl.disabled = false
                            } else {
                                // プラン固定の設定があるため入力不可
                                inputEl.readOnly = true
                                inputEl.disabled = true
                                inputEl.value = jsonParams.custom_excessive_unit_price
                            }
                        }
                        break
                }
            })
        })
    }

    const resetPlan = (el) => {
        Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
            let name = inputEl.id
            const column = name.replace(new RegExp(`^${planPrefix}[0-9]+_`), "")
            switch(column) {
                case 'custom_basic_price':
                case 'custom_free_limit':
                case 'custom_excessive_unit_price':
                    inputEl.readOnly = false
                    inputEl.disabled = false
                    inputEl.value = ''
                    break
            }
        })
    }

    const setOptionInfo = (el, json) => {
        Array.from(el.getElementsByClassName("watch_changes")).forEach(element => {
            let optionId = element.value
            if(optionId === '') {
                resetOption(el)
                return
            }
            optionId = optionId - 0

            let jsonParams = null
            Array.from(json).some(params => {
                if(params.id !== optionId) {
                    return false
                }
                jsonParams = params
                return true
            })
            if(jsonParams === null) return

            Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
                let name = inputEl.id
                const column = name.replace(new RegExp(`^${optionPrefix}[0-9]+_`), "")
                switch(column) {
                    case 'custom_basic_price':
                        inputEl.readOnly = true
                        inputEl.disabled = true
                        if(jsonParams.custom_basic_price !== null) {
                            inputEl.value = jsonParams.custom_basic_price
                        }
                        break
                    case 'custom_free_limit':
                        inputEl.readOnly = true
                        inputEl.disabled = true
                        if(jsonParams.custom_free_limit !== null) {
                            inputEl.value = jsonParams.custom_free_limit
                        }
                        break
                    case 'custom_excessive_unit_price':
                        if(jsonParams.custom_excessive_unit_price !== null) {
                            inputEl.readOnly = true
                            inputEl.disabled = true
                            inputEl.value = jsonParams.custom_excessive_unit_price
                        }
                        break
                }
            })
        })
    }

    const resetOption = (el) => {
        Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
            let name = inputEl.id
            const column = name.replace(new RegExp(`^${optionPrefix}[0-9]+_`), "")
            switch(column) {
                case 'custom_basic_price':
                case 'custom_free_limit':
                case 'custom_excessive_unit_price':
                    inputEl.readOnly = true
                    inputEl.disabled = true
                    inputEl.value = ''
                    break
            }
        })
    }

    const setCommissionInfo = (el, json) => {
        let contractCommissionId = null
        Array.from(el.getElementsByTagName("input")).some(inputEl => {
            if(!inputEl.id.match(new RegExp(`^${commissionPrefix}[0-9]+_id`), "")) {
                return false
            }
            if(inputEl.value.length === 0) return false
            contractCommissionId = inputEl.value
            return true
        })

        Array.from(el.getElementsByClassName("watch_changes")).forEach(element => {
            let commissionId = element.value
            if(commissionId === '') {
                resetCommission(el)
                return
            }
            commissionId = commissionId - 0

            let jsonParams = null
            Array.from(json).some(params => {
                if(params.id !== commissionId) {
                    return false
                }
                jsonParams = params
                return true
            })
            if(jsonParams === null) return

            Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
                let name = inputEl.id
                const column = name.replace(new RegExp(`^${commissionPrefix}[0-9]+_`), "")
                switch(column) {
                    case 'price':
                        inputEl.readOnly = true
                        inputEl.disabled = true
                        if(contractCommissionId === null) {
                            inputEl.readOnly = false
                            inputEl.disabled = false
                            if(jsonParams.default_price !== null) {
                                inputEl.value = jsonParams.default_price
                            }
                        }
                        break
                }
            })
        })
    }

    const resetCommission = (el) => {
        Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
            let name = inputEl.id
            const column = name.replace(new RegExp(`^${commissionPrefix}[0-9]+_`), "")
            switch(column) {
                case 'price':
                    inputEl.readOnly = false
                    inputEl.disabled = false
                    inputEl.value = null
                    break
            }
        })
    }

    const setCampaignInfo = (el, json) => {
        Array.from(el.getElementsByClassName("watch_changes")).forEach(element => {
            let campaignId = element.value
            if(campaignId === '') {
                resetCampaign(el)
                return
            }
            campaignId = campaignId - 0

            let jsonParams = null
            Array.from(json).some(params => {
                if(params.id !== campaignId) {
                    return false
                }
                jsonParams = params
                return true
            })
            if(jsonParams === null) return

            Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
                let name = inputEl.id
                const column = name.replace(new RegExp(`^${campaignPrefix}[0-9]+_`), "")
                switch(column) {
                    case 'code':
                        inputEl.readOnly = true
                        inputEl.disabled = true
                        inputEl.value = jsonParams.code
                        break
                }
            })
            Array.from(el.getElementsByClassName("staff_memo")).forEach(inputEl => {
                inputEl.innerHTML = jsonParams.staff_memo
            })
        })
    }

    const resetCampaign = (el) => {
        Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
            let name = inputEl.id
            const column = name.replace(new RegExp(`^${campaignPrefix}[0-9]+_`), "")
            switch(column) {
                case 'code':
                    inputEl.readOnly = false
                    inputEl.disabled = false
                    inputEl.value = ''
                    break
            }
        })
        Array.from(el.getElementsByClassName("staff_memo")).forEach(inputEl => {
            inputEl.innerHTML = ''
        })
    }
}
